import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { FC } from "react";
import { FormFieldTypes } from "types/enums";

import { FormFieldSettingsFields } from "./FormFieldSettingsFields";
import { FormFieldOverrideContext } from "../FormFieldsForm/formFieldOverrides";
import { FormFieldsFormData } from "../FormFieldsForm/formSchema";

interface FormFieldSettingsFormProps {
    type: FormFieldTypes;
    formFieldId: string;
    formStructureId: string;
    overrideContext?: FormFieldOverrideContext;
}

export const FormFieldSettingsForm: FC<FormFieldSettingsFormProps> = ({
    type,
    formFieldId,
    formStructureId,
    overrideContext,
}) => {
    const { getValues } = useGeneralForm();
    const formFields = getValues("formFields");
    const index = formFields.findIndex((field: FormFieldsFormData) => field.id === formFieldId);

    if (index < 0) return null;

    return (
        <FormFieldSettingsFields
            type={type}
            propertyPath={`formFields.${index}`}
            formStructureId={formStructureId}
            overrideContext={overrideContext}
        />
    );
};
